<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" hasBreadcrumb>
        <template #afterTitle>
          <div class="d-flex gap-2">
            <McButton
              variant="secondary"
              class="ms-3"
              :text="$t('global.action.cancel')"
              icon="icon-outline_close"
              @click="handleCancel"
            />

            <McButton
              variant="primary"
              type="submit"
              :text="$t('global.save')"
              icon="icon-outline_save"
              @click="handleSubmit"
            />
          </div>
        </template>
      </PageHeader>
    </div>

    <b-row class="g-0">
      <b-col md="8">
        <FormulateForm
          ref="formCheckRef"
          v-model="formValuesCheck"
          :errors="formErrorsCheck"
          class="mc-form"
        >
          <b-card>
            <b-row class="g-0">
              <b-col md="4">
                <FormulateInput
                  id="select-vehicle"
                  ref="select-vehicle"
                  v-model="newForm.vehicleId"
                  type="value-help"
                  name="licensePlateSelect"
                  :label="`${$t('global.object.licensePlate')}`"
                  :placeholder="`${$t('global.form.select')} ${$t('global.object.licensePlate')}`"
                  :listGetter="resourcefulQuery.licensePlate"
                  :tableFields="tableFields.licensePlate"
                  :trackBy="'id'"
                  :displayedBy="'licensePlate'"
                  :initialObject="initialObject.vehicle"
                  validation="required"
                  error-behavior="submit"
                  validation-behavior="submit"
                  :modalTitle="$t('global.object.licensePlate')"
                  :visibleValidationErrors="true"
                  @input="handleChangeVehicleId"
                />
              </b-col>
              <b-col md="5">
                <FormulateInput
                  v-model="newForm.period"
                  isShow="true"
                  :label="$t('landMeasurement.field.tripPeriod')"
                  :placeholder="$t('landMeasurement.field.tripPeriod')"
                  type="date-picker"
                  datepickerType="datetime"
                  valueType="YYYY-MM-DDTHH:mm:ss.SSSZ"
                  format="DD MMM YYYY HH:mm"
                  titleFormat="DD MMM YYYY"
                  rangeSeparator=" - "
                  :range="true"
                  :draft="true"
                  :disabled-date="disabledRange"
                  :shortcuts="makeShortcuts"
                  validation="required"
                  error-behavior="submit"
                  validation-behavior="submit"
                  :confirm="true"
                  :confirmText="$t('global.action.apply')"
                  @input="handleChangeDateRange"
                />
              </b-col>
              <b-col md="3" class="mc-land-filter">
                <McButton
                  class="px-1"
                  variant="primary"
                  size="full"
                  type="submit"
                  :text="$t('global.action.viewHistoryTrip')"
                  @click="checkTrip()"
                />
              </b-col>
            </b-row>
            <b-row class="g-0">
              <GmapMap
                id="map"
                ref="MapAddress"
                :center="$store.state.map.center"
                :zoom="Number($store.state.map.zoom)"
                :options="gMapOptions"
                class="mc-map-land"
              >
                <GmapPolyline :path="pathCoordinates" />
              </GmapMap>
              <div v-show="hasTripViewed" class="delete-zone">
                <a href="javascript: void(0);" class="text-secondary" @click="checkTrip()">
                  <i class="mc-fa icon-outline_archive"></i>
                </a>
              </div>
            </b-row>
          </b-card>
        </FormulateForm>
      </b-col>
      <b-col md="4">
        <FormulateForm ref="formRef" v-model="formValues" :errors="formErrors" class="mc-form">
          <button
            ref="saveButtonRef"
            class="invisible"
            variant="primary"
            type="submit"
            @click="handleCreate"
          >
            {{ $t('global.save') }}
          </button>
          <b-card class="mc-form mc-form__infomartion">
            <h4 class="card-title">
              {{ $t('landMeasurement.fleetInformation') }}
            </h4>
            <ReadOnly :items="readOnlyItems" />
            <hr />
            <h4 class="card-title">
              {{ $t('landMeasurement.landInformation') }}
            </h4>
            <div v-if="displayForm">
              <b-col md="6">
                <FormulateInput
                  v-model="newForm.polyZoneData.area"
                  :label="$t('landMeasurement.field.landArea')"
                  :placeholder="$t('landMeasurement.field.landArea')"
                  type="text"
                  :disabled="true"
                />
              </b-col>
              <FormulateInput
                v-model="newForm.landName"
                :label="$t('landMeasurement.field.landName')"
                :placeholder="$t('landMeasurement.field.landName')"
                type="text"
                validation="required:trim|max:128"
                error-behavior="submit"
                validation-behavior="submit"
              >
                <template #label>
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="teal-300"
                      >{{ $t('landMeasurement.field.landName') }}
                      <i class="text-danger">*</i></label
                    >
                  </div>
                </template>
              </FormulateInput>
              <FormulateInput
                v-model="newForm.landDescription"
                :label="$t('landMeasurement.field.description')"
                :placeholder="$t('landMeasurement.field.description')"
                type="text"
                validation="max:256"
                error-behavior="submit"
                validation-behavior="submit"
              />
              <b-row class="g-0">
                <b-col md="6">
                  <FormulateInput
                    v-model="newForm.provinceSelected"
                    type="select-resourceful"
                    :label="$t('global.object.province')"
                    :placeholder="`${$t('global.form.select')} ${$t('global.object.province')}`"
                    :trackBy="'province'"
                    :optionsGetter="resourcefulQuery.province"
                    :optionLabelFn="({ item }) => item.province"
                    :initialObject="initialObject.province"
                    :useInitialFallback="true"
                  />
                </b-col>
                <b-col md="6">
                  <FormulateInput
                    v-model="newForm.citySelected"
                    type="select-resourceful"
                    :label="$t('global.object.city')"
                    :placeholder="`${$t('global.form.select')} ${$t('global.object.city')}`"
                    :trackBy="'city'"
                    :optionsGetter="resourcefulQuery.city"
                    :optionLabelFn="({ item }) => item.city"
                    :initialObject="initialObject.city"
                    :useInitialFallback="true"
                  />
                </b-col>
              </b-row>
              <b-row class="g-0">
                <b-col md="6">
                  <FormulateInput
                    v-model="newForm.startWork"
                    type="time"
                    format="HH:mm"
                    value-type="HH:mm"
                    validation="required"
                    error-behavior="submit"
                    validation-behavior="submit"
                  >
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="teal-300"
                          >{{ $t('landMeasurement.field.startWork') }}
                          <i class="text-danger">*</i></label
                        >
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
                <b-col md="6">
                  <FormulateInput
                    v-model="newForm.endWork"
                    type="time"
                    format="HH:mm"
                    value-type="HH:mm"
                    validation="required"
                    error-behavior="submit"
                    validation-behavior="submit"
                  >
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="teal-300"
                          >{{ $t('landMeasurement.field.endWork') }}
                          <i class="text-danger">*</i></label
                        >
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
              </b-row>
            </div>
            <div v-else class="mc-form mc-form__infomartion mc-nodata__zone">
              <figure class="mc-nodata__zone mc-nodata__zone-img">
                <img :src="illustrationPath" alt />
              </figure>
              <h5>
                {{ $t('landMeasurement.findTripText') }}
              </h5>
              <p>
                {{ $t('landMeasurement.zoneText') }}
              </p>
            </div>
          </b-card>
        </FormulateForm>
      </b-col>
    </b-row>
    <b-modal
      id="mc-modal-back"
      ref="mc-modal-back"
      class="mc-modal"
      :title="$t('global.confirmation.title')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p class="mc-paragraph">
          {{ $t('global.confirmation.question') }}
        </p>
        <p class="mc-paragraph">
          {{ $t('global.confirmation.sure') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.confirmation.exitPage')"
            @click="handleExitPage"
          />
          <McButton
            variant="primary"
            :text="$t('global.confirmation.stayPage')"
            @click="cancel()"
          />
        </div>
      </template>
    </b-modal>

    <b-modal
      id="mc-modal-reset"
      ref="mc-modal-reset"
      v-model="showModalReset"
      class="mc-modal"
      :title="$t('global.alert.text.warning')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p v-if="!isDetail" class="mc-paragraph">
          {{ $t('global.confirmation.questionChangeFleetAndPeriod') }}
        </p>
        <p v-else class="mc-paragraph">
          {{ $t('global.confirmation.questionChangeFleetAndPeriodDetail') }}
        </p>
      </div>
      <template #modal-footer="">
        <div class="d-flex mx-0">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.alert.text.cancel')"
            @click="handleCancelReset"
          />
          <McButton
            variant="primary"
            :text="`${$t('global.yes')}, ${$t('global.alert.text.confirm')}`"
            @click="handleApplyReset"
          />
        </div>
      </template>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import ReadOnly from './components/ReadOnly.vue'
import { Helper } from '@/mixin/helper'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
import isEqual from 'lodash/isEqual'
import { mapGetters } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'
moment.locale('id')

import { GET_VEHICLES_PAGINATED } from '@/services/api/master/fleet'
import { GET_PROVINCES, GET_CITIES } from '@/services/api/master/address'
import { GET_SUMMARY_TRIP, GET_RAW_LOCATION } from '@/services/api/fleet'
import { GET_VEHICLE_DETAILS } from '@/services/api/vehicle/vehicleDetail'
import {
  CREATE_LAND_MEASUREMENT,
  GET_ZONE,
  UPDATE_LAND_MEASUREMENT,
} from '@/services/api/landMeasurement/landMeasurement'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Land Measurement',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    ReadOnly,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      formValues: {},
      formErrors: {},
      formValuesCheck: {},
      formErrorsCheck: {},
      initialObject: {
        vehicle: {},
        province: {},
        city: {},
      },

      province: [],
      cities: [],
      selectedProvinceRegionId: null,

      chassisNo: '-',

      pastDate: null,
      futureEnd: null,

      pathCoordinates: [],
      polyZoneData: {
        polyData: [],
        latitude: '',
        longitude: '',
        latLong: '',
        area: null,
      },
      defaultForm: {},
      newForm: {},
      summaryTrips: {},
      licensePlate: '-',
      totalTrip: '-',
      carMarker: null,
      polyline: null,
      hasTripViewed: false,
      temporaryVehicleId: null,
      temporaryLicensePlate: null,
      oldData: null,
      temporaryPeriod: [],
      triggerResetType: '',
      showModalReset: false,
      polylines: [],

      displayForm: false,
      isDetail: false,
      changePoly: false,
      gMapOptions: {
        mapTypeId: 'hybrid',
      },
      isFromDetail: false,
    }
  },
  computed: {
    google: gmapApi,
    title() {
      const action = this.$route.params.id === undefined ? 'create' : 'change'
      return this.$t('global.action.' + action) + ' ' + this.$t('landMeasurement.title')
    },
    readOnlyItems() {
      const items = [
        {
          label:
            this.$t('landMeasurement.field.licensePlate') +
            '/' +
            this.$t('landMeasurement.field.chassisNo'),
          value: `${this.licensePlate} / ${this.chassisNo}`,
          bold: true,
        },
        {
          label: this.$t('landMeasurement.field.totalDistance'),
          value: this.totalTrip !== '-' ? this.thousandFormat(this.totalTrip) : '-',
          bold: true,
        },
      ]

      return items
    },

    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },

    resourcefulQuery() {
      return {
        licensePlate: async (opts) => {
          let result = {}

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            orderBy: opts.sorts,
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehiclesPaginated.vehiclesPaginated

          result = {
            metadata: {
              total_count: data.pagination.total,
              page: data.pagination.page,
            },
            data: {
              paginated_result: data.data,
            },
          }

          return result
        },
        province: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
          }

          const { data, pagination } = await this.searchProvinces(filter)

          let provinceOptions = (data || [])
            .map((item) => ({
              regionId: item.regionId,
              province: item.name,
            }))
            .sort((a, b) => a.province.localeCompare(b.province))

          const isFirstPage = !opts.page || Number(opts.page) === 1

          if (isFirstPage && this.newForm.provinceSelected) {
            const selectedProvinceName = this.normalizeRegionName(this.newForm.provinceSelected)
            const normalizedSearch = this.normalizeRegionName(opts.search)
            const isAlreadyInOptions = provinceOptions.some(
              (item) => this.normalizeRegionName(item.province) === selectedProvinceName
            )
            const isMatchSearch =
              !normalizedSearch || selectedProvinceName.includes(normalizedSearch)

            if (!isAlreadyInOptions && isMatchSearch) {
              provinceOptions = [
                {
                  regionId: this.selectedProvinceRegionId,
                  province: this.newForm.provinceSelected,
                },
                ...provinceOptions,
              ]
            }
          }

          this.province = provinceOptions

          return {
            metadata: {
              total_count: Math.max(pagination?.total || 0, provinceOptions.length),
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: provinceOptions,
            },
          }
        },
        city: async (opts) => {
          const selectedCity = this.newForm.citySelected

          if (!this.selectedProvinceRegionId) {
            let fallbackOptions = []
            const isFirstPage = !opts.page || Number(opts.page) === 1
            const normalizedSearch = this.normalizeRegionName(opts.search)
            const normalizedSelectedCity = this.normalizeRegionName(selectedCity)

            if (
              isFirstPage &&
              selectedCity &&
              (!normalizedSearch || normalizedSelectedCity.includes(normalizedSearch))
            ) {
              fallbackOptions = [
                {
                  regionId: null,
                  city: selectedCity,
                },
              ]
            }

            this.cities = fallbackOptions

            return {
              metadata: {
                total_count: fallbackOptions.length,
                page: 1,
              },
              data: {
                paginated_result: fallbackOptions,
              },
            }
          }

          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            search: opts.search || undefined,
            provinceId: this.selectedProvinceRegionId,
          }

          const { data, pagination } = await this.searchCities(filter)

          let cityOptions = (data || [])
            .map((item) => ({
              regionId: item.regionId,
              city: item.name,
            }))
            .sort((a, b) => a.city.localeCompare(b.city))

          const isFirstPage = !opts.page || Number(opts.page) === 1

          if (isFirstPage && selectedCity) {
            const normalizedSelectedCity = this.normalizeRegionName(selectedCity)
            const normalizedSearch = this.normalizeRegionName(opts.search)
            const isAlreadyInOptions = cityOptions.some(
              (item) => this.normalizeRegionName(item.city) === normalizedSelectedCity
            )
            const isMatchSearch =
              !normalizedSearch || normalizedSelectedCity.includes(normalizedSearch)

            if (!isAlreadyInOptions && isMatchSearch) {
              cityOptions = [
                {
                  regionId: null,
                  city: selectedCity,
                },
                ...cityOptions,
              ]
            }
          }

          this.cities = cityOptions

          return {
            metadata: {
              total_count: Math.max(pagination?.total || 0, cityOptions.length),
              page: pagination?.page || opts.page || 1,
            },
            data: {
              paginated_result: cityOptions,
            },
          }
        },
      }
    },

    tableFields() {
      return {
        licensePlate: [
          {
            key: 'licensePlate',
            label: this.$t('global.object.licensePlate'),
          },
          {
            label: this.$t('global.field.vehicleType'),
            key: 'vehicleType',
            formatter(val) {
              const label = [val.category, val.model, val.type]
              return label.filter((x) => x !== null).join('/')
            },
            isSortable: false,
          },
        ],
      }
    },

    makeShortcuts() {
      return [
        {
          text: this.$t('global.time.today'),
          onClick: () => {
            const dateStart = new Date()
            const dateEnd = new Date()
            dateStart.setHours(0, 0, 0, 0)
            dateEnd.setHours(23, 59, 59, 0)
            return [dateStart, dateEnd]
          },
        },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const dateStart = new Date()
            const dateEnd = new Date()
            dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
            dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
            dateStart.setHours(0, 0, 0, 0)
            dateEnd.setHours(23, 59, 59, 0)
            return [dateStart, dateEnd]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },
  },

  watch: {
    'newForm.provinceSelected': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return

        const normalizedOldValue = this.normalizeRegionName(oldValue)
        const normalizedNewValue = this.normalizeRegionName(newValue)
        const isProvinceActuallyChanged =
          oldValue !== null && oldValue !== undefined && normalizedOldValue !== normalizedNewValue

        if (isProvinceActuallyChanged) {
          this.newForm.citySelected = null
          this.initialObject.city = {}
          this.cities = []
        }

        await this.resolveSelectedProvince(newValue)

        if (this.newForm.citySelected) {
          await this.resolveSelectedCity(this.newForm.citySelected)
        }
      },
    },
    'newForm.citySelected': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return

        await this.resolveSelectedCity(newValue)
      },
    },
    showModalReset: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$refs['mc-modal-reset'].show()
          return
        }

        this.$refs['mc-modal-reset'].hide()
        this.triggerResetType = ''
      },
    },
  },

  created() {
    const currentDate = moment(new Date())
    const pastMonth = moment(currentDate).subtract(3, 'months')
    const pastDate = moment(pastMonth).endOf('month')

    this.pastDate = new Date(pastDate)
    this.futureEnd = new Date(currentDate)

    this.createZoneFlag = false
    this.defaultForm = {
      vehicleId: null,
      period: [],
      startWork: null,
      endWork: null,
      provinceSelected: null,
      citySelected: null,
      landName: null,
      landDescription: null,
      polyZoneData: JSON.parse(JSON.stringify(this.polyZoneData)),
    }
    this.newForm = JSON.parse(JSON.stringify(this.defaultForm))
  },

  async mounted() {
    const self = this
    await this.$refs.MapAddress.$mapPromise.then((map) => {
      self.map = map
    })

    if (this.$route.params.data) {
      this.displayForm = true
      const receivedData = this.$route.params.data
      if (receivedData) {
        this.track('View Form Pengukuran Lahan')
        this.showData(receivedData)
      }
    } else if (this.$route.query?.vehicleId) {
      this.displayForm = true
      this.track('View Form Pengukuran Lahan')
      const storageKey = this.$route.query?.key
      const landMeasurementData = JSON.parse(localStorage.getItem(storageKey))
      if (!landMeasurementData) {
        this.$mcToast.error(this.$t('global.text.noData'))
        this.$router.replace({
          path: this.$route.path,
          query: {},
        })
        return
      }
      this.showData(landMeasurementData)
    }

    if (this.$route.params.id) {
      this.track('View Details Area Information')
      this.getDetail(this.$route.params.id)
      this.displayForm = true
      this.isDetail = true
      this.isFromDetail = true
    }
  },

  methods: {
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    normalizeRegionName(value) {
      return (value || '').trim().toLowerCase()
    },
    findExactRegionByName(options, name) {
      const normalizedName = this.normalizeRegionName(name)
      if (!normalizedName) return null

      return options.find((item) => this.normalizeRegionName(item?.name) === normalizedName) || null
    },
    async searchProvinces(filter) {
      const response = await this.$apollo.query({
        query: GET_PROVINCES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.provinces?.data || [],
        pagination: response?.data?.data?.provinces?.pagination || {},
      }
    },
    async searchCities(filter) {
      const response = await this.$apollo.query({
        query: GET_CITIES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.cities?.data || [],
        pagination: response?.data?.data?.cities?.pagination || {},
      }
    },
    async resolveSelectedProvince(provinceName) {
      this.selectedProvinceRegionId = null

      const normalizedProvinceName = this.normalizeRegionName(provinceName)
      if (!normalizedProvinceName) {
        this.initialObject.province = {}
        return
      }

      const selectedFromOptions = this.province.find(
        (item) => this.normalizeRegionName(item.province) === normalizedProvinceName
      )
      if (selectedFromOptions?.regionId) {
        this.selectedProvinceRegionId = selectedFromOptions.regionId
        this.initialObject.province = {
          regionId: selectedFromOptions.regionId,
          province: selectedFromOptions.province,
        }

        if (selectedFromOptions.province !== provinceName) {
          this.newForm.provinceSelected = selectedFromOptions.province
        }
        return
      }

      const { data } = await this.searchProvinces({
        pagination: {
          page: 1,
          show: 50,
        },
        search: provinceName,
      })

      const selectedProvince = this.findExactRegionByName(data, provinceName)
      if (selectedProvince) {
        this.selectedProvinceRegionId = selectedProvince.regionId
        this.initialObject.province = {
          regionId: selectedProvince.regionId,
          province: selectedProvince.name,
        }

        if (selectedProvince.name !== provinceName) {
          this.newForm.provinceSelected = selectedProvince.name
        }
        return
      }

      this.selectedProvinceRegionId = null
      this.initialObject.province = {
        regionId: null,
        province: provinceName,
      }
    },
    async resolveSelectedCity(cityName) {
      const normalizedCityName = this.normalizeRegionName(cityName)
      if (!normalizedCityName) {
        this.initialObject.city = {}
        return
      }

      if (!this.selectedProvinceRegionId) {
        this.initialObject.city = {
          regionId: null,
          city: cityName,
        }
        return
      }

      const selectedFromOptions = this.cities.find(
        (item) => this.normalizeRegionName(item.city) === normalizedCityName
      )

      if (selectedFromOptions?.regionId) {
        this.initialObject.city = {
          regionId: selectedFromOptions.regionId,
          city: selectedFromOptions.city,
        }

        if (selectedFromOptions.city !== cityName) {
          this.newForm.citySelected = selectedFromOptions.city
        }
        return
      }

      const { data } = await this.searchCities({
        pagination: {
          page: 1,
          show: 50,
        },
        search: cityName,
        provinceId: this.selectedProvinceRegionId,
      })

      const selectedCity = this.findExactRegionByName(data, cityName)
      if (selectedCity) {
        this.initialObject.city = {
          regionId: selectedCity.regionId,
          city: selectedCity.name,
        }

        if (selectedCity.name !== cityName) {
          this.newForm.citySelected = selectedCity.name
        }
        return
      }

      this.initialObject.city = {
        regionId: null,
        city: cityName,
      }
    },
    disabledRange: function (date, currentValue) {
      const MAX_DAYS_SELECTED = 3

      // Disable future dates & dates earlier than 3 months ago
      if (new Date(date) <= new Date(this.pastDate) || new Date(date) >= new Date(this.futureEnd)) {
        return true
      }

      // When first date is selected, limit the range to 3 days
      const MILISECONDS_IN_A_DAY = 24 * 3600 * 1000
      if (currentValue && currentValue[0] && !currentValue[1]) {
        const startDate = new Date(currentValue[0])
        const minDate = new Date(
          startDate.getTime() - (MAX_DAYS_SELECTED - 1) * MILISECONDS_IN_A_DAY
        )
        const maxDate = new Date(
          startDate.getTime() + (MAX_DAYS_SELECTED - 1) * MILISECONDS_IN_A_DAY
        )
        return date < minDate || date > maxDate
      }

      return false
    },
    async checkTrip() {
      if (
        this.newForm.period.length === 0 ||
        this.newForm.period.every((element) => element === null) ||
        !this.newForm.vehicleId
      ) {
        return false
      }

      this.displayForm = true
      const startDate = new Date(this.newForm.period[0])
      const endDate = new Date(this.newForm.period[1])
      const timeDiff = Math.abs(endDate - startDate)
      const oneDay = 24 * 60 * 60 * 1000
      const checkPeriode = timeDiff > oneDay

      if (checkPeriode) {
        return this.$mcToast.warning(this.$t('global.text.checkLandPeriode'))
      }

      const filter = {
        vehicleId: parseInt(this.newForm.vehicleId),
        startDate: this.momentToISOString(`${this.newForm.period[0]}`),
        endDate: this.momentToISOString(`${this.newForm.period[1]}`),
      }

      const tripHistory = await this.getTripHistory(filter)
      const summaryTrips = tripHistory.summaryTrips
      this.totalTrip = tripHistory.totalTrip ? tripHistory.totalTrip : '-'
      const detailSummaryTrips = summaryTrips.map((trip, index) => {
        if (index === summaryTrips.length - 1) {
          return trip
        } else {
          const newDetail = {
            sentOn: trip.startTime,
            latitude: trip.startLat,
            longitude: trip.startLong,
            vehicleId: trip.vehicleId,
            speed: trip.maxSpeed,
            direction: 0,
            __typename: 'RawLocation',
          }

          const updatedTrip = {
            ...trip,
            details: [newDetail, ...trip.details],
          }

          return updatedTrip
        }
      })

      const vehicleData = await this.getVehicle(this.newForm.vehicleId)
      if (!detailSummaryTrips || detailSummaryTrips.length == 0) {
        return this.$mcToast.warning(this.$t('global.text.noTripHistory'))
      }

      if (vehicleData) {
        this.licensePlate = vehicleData.licensePlate
        this.chassisNo = vehicleData.chassisNumber ? vehicleData.chassisNumber : '-'
      }
      this.assignTemporaryData()
      let rawLocationsData = []
      detailSummaryTrips.forEach((trip) => {
        if (trip.details) {
          rawLocationsData = rawLocationsData.concat(trip.details)
        }
      })

      let east = -Infinity
      let west = Infinity
      let north = -Infinity
      let south = Infinity

      rawLocationsData.forEach((item) => {
        east = Math.max(east, item.longitude)
        west = Math.min(west, item.longitude)
        north = Math.max(north, item.latitude)
        south = Math.min(south, item.latitude)
      })

      const boundsCoords = [
        { lat: north, lng: west },
        { lat: north, lng: east },
        { lat: south, lng: east },
        { lat: south, lng: west },
      ]

      const map = new this.google.maps.Map(document.getElementById('map'), {
        center: this.pathCoordinates[0],
        zoom: 15,
        mapTypeId: this.google.maps.MapTypeId.HYBRID,
      })

      this.polylines = []

      detailSummaryTrips.forEach((trip) => {
        const rawLocations = trip.details || []

        const pathCoordinates = rawLocations.map(
          (location) =>
            new this.google.maps.LatLng(Number(location.latitude), Number(location.longitude))
        )
        const polyline = new this.google.maps.Polyline({
          path: pathCoordinates,
          geodesic: true,
          strokeColor: '#f41d00',
          strokeOpacity: 1.0,
          strokeWeight: 3,
        })

        polyline.setMap(map)

        this.polylines.push(polyline)
      })

      const firstTripDetails = tripHistory.summaryTrips[0].details || []

      const lastDetail = firstTripDetails[firstTripDetails.length - 1]
      let lastLocation = []
      if (lastDetail) {
        lastLocation = new this.google.maps.LatLng(
          Number(lastDetail.latitude),
          Number(lastDetail.longitude)
        )
      }
      const icon = vehicleData.vehicleType ? vehicleData.vehicleType.icon : 'car'
      const carIcon = {
        url: require(`@/assets/images/vehicles/${icon}/${icon}-dark-grey.png`),
        scaledSize: new this.google.maps.Size(40, 40),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(20, 20),
      }

      this.carMarker = new this.google.maps.Marker({
        position: lastLocation,
        map: map,
        icon: carIcon,
      })

      const bounds = new this.google.maps.LatLngBounds()
      this.pathCoordinates.forEach((coordinate) => {
        bounds.extend(coordinate)
      })
      bounds.extend(lastLocation)
      boundsCoords.forEach((coordinate) => {
        bounds.extend(coordinate)
      })
      map.fitBounds(bounds)

      this.polygonZone = new this.google.maps.Polygon({
        paths: boundsCoords,
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      })

      this.polygonZone.setMap(map)

      this.polygonZone.getPaths().forEach((path) => {
        this.changePoly = true
        this.google.maps.event.addListener(path, 'insert_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'remove_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'set_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.updatePolygonCoordsState(path)
      })

      this.track('Create Lahan Via Modul Pengukuran Lahan')
    },
    updatePolygonCoordsState(poly) {
      this.newForm.polyZoneData.polyData = []

      let latLong = []
      for (let i = 0; i < poly.getLength(); i++) {
        let koma = ''
        if (poly.getLength() - 1 != i) {
          koma = ','
        }

        let lat = Number(poly.getAt(i).lat()).toFixed(8)
        let lang = Number(poly.getAt(i).lng()).toFixed(8)
        this.newForm.polyZoneData.latitude += lat + koma
        this.newForm.polyZoneData.longitude += lang + koma

        this.newForm.polyZoneData.polyData.push([lat, lang])
        latLong.push('(' + lat + ', ' + lang + ')')
      }

      this.newForm.polyZoneData.latLong = latLong.join(', ')

      if (!this.$route.params.id || this.changePoly) {
        this.newForm.polyZoneData.area = this.google.maps.geometry.spherical.computeArea(poly)
        if (!Number.isInteger(this.newForm.polyZoneData.area)) {
          this.newForm.polyZoneData.area = this.thousandFormat(
            this.newForm.polyZoneData.area.toFixed(2)
          )
        }
      }
    },
    async showData(receivedData) {
      this.newForm.vehicleId = receivedData.vehicleId
      this.licensePlate = receivedData.licensePlate
      this.initialObject.vehicle = {
        id: this.newForm.vehicleId,
        licensePlate: receivedData.licensePlate,
      }
      const startDate = this.convertDate(receivedData.startDate)
      const endDate = this.convertDate(receivedData.endDate)
      this.newForm.period = [startDate, endDate]
      this.initMapPoly(receivedData, this.isFromDetail)
      this.newForm.polyZoneData.area = Number.isInteger(
        JSON.parse(receivedData.landMeasurement).area
      )
        ? JSON.parse(receivedData.landMeasurement).area.toString()
        : this.thousandFormat(JSON.parse(receivedData.landMeasurement).area.toFixed(2))
      this.licensePlate = receivedData.licensePlate

      const res = await this.$apollo.query({
        query: GET_VEHICLE_DETAILS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: { id: parseInt(receivedData.vehicleId) },
        },
      })
      this.chassisNo = res.data.vehicle.vehicle.chassisNumber
        ? res.data.vehicle.vehicle.chassisNumber
        : '-'
      this.assignTemporaryData()
    },
    async initMapPoly(data, isFromDetail) {
      let filter = {
        startDate: this.momentToISOString(`${data.startDate}`),
        endDate: this.momentToISOString(`${data.endDate}`),
        vehicleId: Number(data.vehicleId),
        pagination: {
          page: 1,
          show: 99999,
        },
        type: 'moving',
      }
      let response = data.summaryTrips
      let coordinatesValue = data.landMeasurement.polyData
      if (!isFromDetail) {
        response = await this.getTripHistory(filter)
        coordinatesValue = JSON.parse(data.landMeasurement).polyData
      }
      const summaryTrips = response.summaryTrips
      this.totalTrip = response.totalTrip
      this.polylines = []

      summaryTrips.forEach((trip) => {
        const rawLocations = trip.details || []

        const pathCoordinates = rawLocations.map(
          (location) =>
            new this.google.maps.LatLng(Number(location.latitude), Number(location.longitude))
        )

        const polyline = new this.google.maps.Polyline({
          path: pathCoordinates,
          geodesic: true,
          strokeColor: '#f41d00',
          strokeOpacity: 1.0,
          strokeWeight: 3,
        })

        polyline.setMap(this.map)

        this.polylines.push(polyline)
      })

      const coordinates = coordinatesValue
      let Coords = []
      coordinates.forEach(function (item) {
        Coords.push({
          lat: Number(item[0]),
          lng: Number(item[1]),
        })
      })

      // Construct the polygon.
      this.polygonZone = new this.google.maps.Polygon({
        paths: Coords,
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      })

      // Set the polygon on the map
      this.polygonZone.setMap(this.map)

      const firstTripDetails = summaryTrips[0].details || []

      const lastDetail = firstTripDetails[firstTripDetails.length - 1]
      let lastLocation = []
      if (lastDetail) {
        lastLocation = new this.google.maps.LatLng(
          Number(lastDetail.latitude),
          Number(lastDetail.longitude)
        )
      }
      const icon = data.icon ? data.icon : 'car'
      const carIcon = {
        url: require(`@/assets/images/vehicles/${icon}/${icon}-dark-grey.png`),
        scaledSize: new this.google.maps.Size(40, 40),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(20, 20),
      }

      this.carMarker = new this.google.maps.Marker({
        position: lastLocation,
        map: this.map,
        icon: carIcon,
      })

      // Fit the map to the bounds of the polygon
      const bounds = new this.google.maps.LatLngBounds()
      Coords.forEach((coord) => {
        bounds.extend(coord)
      })
      this.map.fitBounds(bounds)

      // Optionally, you can set a maximum zoom level to prevent zooming too close
      const maxZoom = 16
      const zoom = Math.min(maxZoom, this.map.getZoom())
      this.map.setZoom(zoom)

      this.polygonZone.getPaths().forEach((path) => {
        this.google.maps.event.addListener(path, 'insert_at', () => {
          this.changePoly = true
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'remove_at', () => {
          this.changePoly = true
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'set_at', () => {
          this.changePoly = true
          this.updatePolygonCoordsState(path)
        })

        this.updatePolygonCoordsState(path)
      })
    },
    getNewData() {
      let data = {}
      let result = {
        isValidate: false,
        data,
        message: '',
      }

      if (this.newForm.polyZoneData.latLong.length == 0) {
        result.message = this.$t('global.text.landGeometry')
        return result
      }
      const startTripDate = this.newForm.period[0].split('T')[0]
      const endTripDate = this.newForm.period[1].split('T')[0]
      const endTripDateDayOne = `${startTripDate}T23:59:59.000+07:00`
      const startTripDateDayTwo = `${endTripDate}T00:00:00.000+07:00`
      const startTrip = new Date(this.newForm.period[0])
      const endTrip = new Date(this.newForm.period[1])
      const startWork = this.newForm.startWork
      const endWork = this.newForm.endWork
      let startWorkTime = new Date(`${startTripDate}T${this.newForm.startWork}`)
      let endWorkTime = new Date(`${endTripDate}T${this.newForm.endWork}`)
      let startWorkDayOne = null
      let endWorkDayOne = null

      let startWorkDayTwo = null
      let endWorkDayTwo = null

      if (this.newForm.polyZoneData.area < 1) {
        result.message = this.$t('global.text.landArea')
        return result
      }

      const isMultiDayTrip = this.isMultiDayTrip(startTripDate, endTripDate)
      if (isMultiDayTrip) {
        const startDate = new Date(startTripDate)
        const day = startDate.getDate()
        const month = startDate.getMonth() + 1
        const year = startDate.getFullYear()
        startWorkDayOne = `${year}-${month.toString().padStart(2, '0')}-${day
          .toString()
          .padStart(2, '0')}T${startWork}:00.000+07:00`

        const endDate = new Date(startTripDate)
        const endDay = endDate.getDate()
        const endMonth = endDate.getMonth() + 1
        const endYear = endDate.getFullYear()
        endWorkDayOne = `${endYear}-${endMonth.toString().padStart(2, '0')}-${endDay
          .toString()
          .padStart(2, '0')}T${endWork}:00.000+07:00`

        const startDateTwo = new Date(endTripDate)
        const dayTwo = startDateTwo.getDate()
        const monthTwo = startDateTwo.getMonth() + 1
        const yearTwo = startDateTwo.getFullYear()
        startWorkDayTwo = `${yearTwo}-${monthTwo.toString().padStart(2, '0')}-${dayTwo
          .toString()
          .padStart(2, '0')}T${startWork}:00.000+07:00`

        const endDateTwo = new Date(endTripDate)
        const endDayTwo = endDateTwo.getDate()
        const endMonthTwo = endDateTwo.getMonth() + 1
        const endYearTwo = endDateTwo.getFullYear()
        endWorkDayTwo = `${endYearTwo}-${endMonthTwo.toString().padStart(2, '0')}-${endDayTwo
          .toString()
          .padStart(2, '0')}T${endWork}:00.000+07:00`

        const startWorkDateOne = new Date(startWorkDayOne)
        if (this.isDateWithinRange(startWorkDateOne, startTrip, endTripDateDayOne)) {
          startWorkTime = startWorkDayOne
        }

        const endWorkDateOne = new Date(endWorkDayOne)
        if (this.isDateWithinRange(endWorkDateOne, startTrip, endTripDateDayOne)) {
          endWorkTime = endWorkDayOne
        }

        const startWorkDateTwo = new Date(startWorkDayTwo)
        if (this.isDateWithinRange(startWorkDateTwo, startTripDateDayTwo, endTrip)) {
          startWorkTime = startWorkDayTwo
        }

        const endWorkDateTwo = new Date(endWorkDayTwo)
        if (this.isDateWithinRange(endWorkDateTwo, startTripDateDayTwo, endTrip)) {
          endWorkTime = endWorkDayTwo
        }

        if (new Date(startWorkTime) > new Date(endWorkTime)) {
          result.message = this.$t('global.text.workTime')
          return result
        }

        if (new Date(startWorkTime) < startTrip) {
          result.message = this.$t('global.text.landStartWorkTime')
          return result
        }

        if (new Date(endWorkTime) > endTrip) {
          result.message = this.$t('global.text.landEndWorkTime')
          return result
        }
      } else {
        if (startTrip > endTrip) {
          result.message = this.$t('global.text.landTripTime')
          return result
        }

        if (startWorkTime > endWorkTime) {
          result.message = this.$t('global.text.workTime')
          return result
        }

        if (startWorkTime < startTrip) {
          result.message = this.$t('global.text.landStartWorkTime')
          return result
        }

        if (endWorkTime > endTrip) {
          result.message = this.$t('global.text.landEndWorkTime')
          return result
        }
      }

      result.data = {
        name: this.newForm.landName,
        description: this.newForm.landDescription ? this.newForm.landDescription.trim() : null,
        vehicleId: parseInt(this.newForm.vehicleId),
        geometry: this.newForm.polyZoneData.latLong,
        landArea: this.reverseThousandFormat(this.newForm.polyZoneData.area),
        province: this.newForm.provinceSelected ? this.newForm.provinceSelected : null,
        city: this.newForm.citySelected ? this.newForm.citySelected : null,
        startTrip: moment(startTrip).toISOString(),
        endTrip: moment(endTrip).toISOString(),
        startWorkTime: moment(startWorkTime).toISOString(),
        endWorkTime: moment(endWorkTime).toISOString(),
      }

      result.isValidate = true
      return result
    },
    handleCreate() {
      const newData = this.getNewData()
      if (!newData.isValidate) {
        return this.$mcToast.warning(newData.message)
      }

      if (this.$route.params.id) {
        this.handleUpdate(newData)
        return
      }

      this.$apollo
        .mutate({
          mutation: CREATE_LAND_MEASUREMENT,
          variables: {
            input: newData.data,
          },
        })
        .then((response) => {
          if (response.data.createZone.isSuccessful) {
            this.track('Save Luas Lahan')
            this.$mcToast.success(this.$t('global.alert.text.added'))
            setTimeout(() => {
              this.$router.push({ name: 'Land Measurement' })
            }, 1000)
          } else {
            this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
            return
          }
        })
      localStorage.removeItem(this.$route.query?.key)
    },
    clearData() {
      if (this.polygonZone) this.polygonZone.setMap(null)
      if (this.carMarker) this.carMarker.setMap(null)
      this.clearMapPoly()
      this.map.setZoom(this.$store.state.map.zoom)

      if (this.$route.params.id) {
        this.newForm.polyZoneData.area = null
        this.totalTrip = '-'
        this.newForm.polyZoneData.latitude = ''
        this.newForm.polyZoneData.longitude = ''
        this.newForm.polyZoneData.polyData = []
        this.newForm.polyZoneData.latLong = ''
        this.hasTripViewed = false
        this.newForm.provinceSelected = null
        this.newForm.citySelected = null
        this.initialObject.province = {}
        this.initialObject.city = {}
        this.selectedProvinceRegionId = null
        this.cities = []
        this.newForm.startWork = null
        this.newForm.endWork = null
      } else {
        this.newForm.polyZoneData.area = null
        this.newForm.landName = null
        this.newForm.landDescription = null
        this.newForm.startWork = null
        this.newForm.endWork = null
        this.totalTrip = '-'
        this.newForm.polyZoneData.latitude = ''
        this.newForm.polyZoneData.longitude = ''
        this.newForm.polyZoneData.polyData = []
        this.newForm.polyZoneData.latLong = ''
        this.hasTripViewed = false
        this.newForm.provinceSelected = null
        this.newForm.citySelected = null
        this.initialObject.province = {}
        this.initialObject.city = {}
        this.selectedProvinceRegionId = null
        this.cities = []
        this.licensePlate = '-'
        this.chassisNo = '-'
      }
    },
    handleSubmit() {
      this.$refs['saveButtonRef'].click()
    },
    handleChangeVehicleId() {
      if (!this.hasTripViewed || this.newForm.vehicleId == this.temporaryVehicleId) return
      this.triggerResetType = 'vehicle'
      setTimeout(() => {
        this.initialObject.vehicle = {
          id: this.newForm.vehicleId,
          licensePlate: this.$refs['select-vehicle'].$children[1].$el.innerText,
        }
        this.showModalReset = true
      }, 300)
    },
    async getDetail(zoneId) {
      const res = await this.$apollo.query({
        query: GET_ZONE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: { zoneId: zoneId },
        },
      })

      const data = res.data.zone.zone
      this.newForm.vehicleId = data.vehicleId
      this.initialObject.vehicle = {
        id: data.vehicleId,
        licensePlate: data.vehicle.licensePlate,
      }
      this.newForm.period = [this.convertDate(data.startTrip), this.convertDate(data.endTrip)]
      this.newForm.polyZoneData.area = this.thousandFormat(data.landArea)
      this.newForm.landName = data.name
      this.newForm.landDescription = data.description
      this.newForm.provinceSelected = data.province
      await this.resolveSelectedProvince(data.province)
      this.newForm.citySelected = data.city
      await this.resolveSelectedCity(data.city)
      this.newForm.startWork = moment(data.startWorkTime).format('HH:mm')
      this.newForm.endWork = moment(data.endWorkTime).format('HH:mm')
      this.licensePlate = data.vehicle.licensePlate
      this.chassisNo = data.vehicle.chassisNumber ? data.vehicle.chassisNumber : '-'
      const filter = {
        vehicleId: parseInt(data.vehicle.id),
        startDate: this.momentToISOString(`${this.newForm.period[0]}`),
        endDate: this.momentToISOString(`${this.newForm.period[1]}`),
      }
      const summaryTrip = await this.getTripHistory(filter)

      this.totalTrip = summaryTrip.totalTrip

      const vehicle = await this.getVehicle(data.vehicle.id)
      let polyData = null
      if (data.geometry) {
        const regex = /\((-?\d+\.\d+),(-?\d+\.\d+)\)/g
        let match
        const resultArray = []

        while ((match = regex.exec(data.geometry)) !== null) {
          const lat = Number(match[1])
          const lon = Number(match[2])
          resultArray.push([lat, lon])
        }
        polyData = resultArray
      }
      const mapData = {
        summaryTrips: summaryTrip,
        landMeasurement: {
          polyData,
        },
        icon: vehicle.vehicleType ? vehicle.vehicleType.icon : 'car',
      }
      this.initMapPoly(mapData, this.isFromDetail)

      this.defaultForm = JSON.parse(JSON.stringify(this.newForm))

      this.oldData = {
        name: data.name,
        description: data.description,
        vehicleId: parseInt(data.vehicleId),
        geometry: data.geometry,
        landArea: Number(data.landArea),
        province: data.province,
        city: data.city,
        startTrip: moment(data.startTrip).toISOString(),
        endTrip: moment(data.endTrip).toISOString(),
        startWorkTime: moment(data.startWorkTime).toISOString(),
        endWorkTime: moment(data.endWorkTime).toISOString(),
      }

      this.assignTemporaryData()
    },

    async handleUpdate(newData) {
      if (!newData?.data?.name || !newData?.data?.startWorkTime || !newData?.data?.endWorkTime)
        return false

      if (await this.areObjectsEqual(newData.data, this.oldData)) {
        return this.$router.push({ name: 'Land Measurement' })
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_LAND_MEASUREMENT,
          variables: {
            input: {
              zoneId: parseInt(this.$route.params.id),
              newData: newData.data,
              oldData: this.oldData,
            },
          },
        })
        .then((response) => {
          if (response.data.updateZone.isSuccessful) {
            this.track('Update Luas Lahan')
            this.$mcToast.success(this.$t('global.alert.text.changed'))
            setTimeout(() => {
              this.$router.push({ name: 'Land Measurement' })
            }, 1000)
          } else {
            this.$mcToast.error(this.$t('global.alert.text.failedSaved'))
          }
        })
    },
    handleChangeDateRange() {
      if (
        !this.hasTripViewed ||
        (this.newForm.period[0] == this.temporaryPeriod[0] &&
          this.newForm.period[1] == this.temporaryPeriod[1])
      )
        return
      this.triggerResetType = 'period'
      this.showModalReset = true
    },
    handleCancelReset() {
      if (this.triggerResetType == 'vehicle') {
        this.newForm.vehicleId = this.temporaryVehicleId
        this.initialObject.vehicle = {
          id: this.newForm.vehicleId,
          licensePlate: this.temporaryLicensePlate,
        }
      } else {
        this.newForm.period = this.temporaryPeriod
      }
      this.showModalReset = false
    },
    handleApplyReset() {
      this.showModalReset = false
      this.clearData()
    },
    assignTemporaryData() {
      this.hasTripViewed = true
      this.temporaryVehicleId = this.newForm.vehicleId
      this.temporaryLicensePlate = this.licensePlate
      this.temporaryPeriod = this.newForm.period
    },
    handleCancel() {
      const keys = new Set([...Object.keys(this.newForm)])
      keys.forEach((key) => {
        if (key == 'polyZoneData') return
        if (this.newForm[key] === '') {
          this.newForm[key] = null
        }
      })

      const keyPolyData = new Set([...Object.keys(this.newForm.polyZoneData)])
      keyPolyData.forEach((key) => {
        if (key != 'area') return
        if (this.newForm[key] == '') {
          this.newForm[key] = null
        }
      })

      if (!isEqual(this.defaultForm, this.newForm)) {
        this.$refs['mc-modal-back'].show()
        return
      }
      this.$router.push({ name: 'Land Measurement' })
    },

    async getVehicle(vehicleId) {
      const res = await this.$apollo.query({
        query: GET_VEHICLE_DETAILS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: { id: parseInt(vehicleId) },
        },
      })

      let result = null
      if (res.data.vehicle.isSuccessful) {
        result = res.data.vehicle.vehicle
      }
      return result
    },

    async getTripHistory(filter) {
      const summaryTrip = await this.$apollo.query({
        query: GET_SUMMARY_TRIP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: parseInt(filter.vehicleId),
            startDate: this.momentToISOString(filter.startDate),
            endDate: this.momentToISOString(filter.endDate),
            pagination: {
              page: 1,
              show: 99999,
            },
            type: 'moving',
          },
        },
      })

      const summaryTrips = summaryTrip.data.summaryTrips.summaryTrips

      const rawLocationPromises = summaryTrips.summaryTrips.map((trip) =>
        this.$apollo.query({
          query: GET_RAW_LOCATION,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              vehicleId: parseInt(filter.vehicleId),
              startDate: this.momentToISOString(`${trip.startTime}`),
              endDate: this.momentToISOString(`${trip.stopTime}`),
            },
          },
        })
      )

      const rawLocationResults = await Promise.all(rawLocationPromises)
      summaryTrips.summaryTrips.forEach((trip, index) => {
        trip.details = rawLocationResults[index].data.rawLocations.rawLocations
      })

      return summaryTrips
    },

    clearMapPoly() {
      this.polylines.forEach((polyline) => {
        polyline.setMap(null)
      })
      this.polylines.length = 0
    },

    areObjectsEqual(newData, oldData) {
      const coordinateRegex = /\((-?\d+\.\d+),(-?\d+\.\d+)\)/g
      let match
      const coordinates = []

      while ((match = coordinateRegex.exec(oldData.geometry)) !== null) {
        const latitude = Number(match[1])
        const longitude = Number(match[2])
        coordinates.push([latitude, longitude])
      }

      const convertCoordinates = coordinates.map((coord) => `(${coord[0]}, ${coord[1]})`).join(', ')

      const coordinatesArray = convertCoordinates.match(/-?\d+\.\d+/g)

      const formattedCoordinates = []
      for (let i = 0; i < coordinatesArray.length; i += 2) {
        const formattedLatitude = Number(coordinatesArray[i]).toFixed(8)
        const formattedLongitude = Number(coordinatesArray[i + 1]).toFixed(8)
        formattedCoordinates.push(`(${formattedLatitude}, ${formattedLongitude})`)
      }

      const result = formattedCoordinates.join(', ')
      oldData.geometry = result

      const checkNewData = JSON.stringify(newData)
      const checkOldData = JSON.stringify(oldData)

      return checkNewData === checkOldData
    },

    convertGeometry(dataString) {
      const regex = /\((-?\d+\.\d+), (-?\d+\.\d+)\)/g
      const matches = [...dataString.matchAll(regex)]
      const dataArray = matches.map((match) => [match[1], match[2]])

      const formattedData = dataArray.map((point) => `(${point[0]},${point[1]})`)
      return `(${formattedData.join(',')})`
    },

    isMultiDayTrip(start, end) {
      const startDateString = start.slice(0, 10)
      const endDateString = end.slice(0, 10)
      return startDateString !== endDateString
    },

    addDateToTimeString(dateString, timeString) {
      const date = new Date(dateString)
      const timeComponents = timeString.split(':')
      date.setUTCHours(Number(timeComponents[0]))
      date.setUTCMinutes(Number(timeComponents[1]))
      return date
    },

    isDateWithinRange(date, start, end) {
      return date >= new Date(start) && date <= new Date(end)
    },

    handleExitPage() {
      localStorage.removeItem(this.$route.query?.key)
      this.$router.push({ name: 'Land Measurement' })
    },
  },
}
</script>
